export const CategorySettingsIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.667 4.8335H10.667"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.99967 4.8335H1.33301"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66634 7.16667C7.95501 7.16667 8.99967 6.122 8.99967 4.83333C8.99967 3.54467 7.95501 2.5 6.66634 2.5C5.37768 2.5 4.33301 3.54467 4.33301 4.83333C4.33301 6.122 5.37768 7.16667 6.66634 7.16667Z"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 12.1665H12"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33301 12.1665H1.33301"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33333 14.5002C10.622 14.5002 11.6667 13.4555 11.6667 12.1668C11.6667 10.8782 10.622 9.8335 9.33333 9.8335C8.04467 9.8335 7 10.8782 7 12.1668C7 13.4555 8.04467 14.5002 9.33333 14.5002Z"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
